'use strict';

var TDChartClassFilterFactory = function TDChartClassFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ServiceDemandDateRangeFilterFactory', 'ServiceDemandNumberOfStopsFilterFactory', 'ServiceDemandTimeOfDayFilterFactory', 'ServiceDemandDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function TDChartClassFilter() {
    DemandFilter.call(this, 'service', 'thematic-demand-chart-service-classes');
    this.registerFilters(injectedFilters);
  }
  TDChartClassFilter.constructor = TDChartClassFilter;
  TDChartClassFilter.prototype = Object.create(DemandFilter.prototype);
  return TDChartClassFilter;
};
TDChartClassFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = TDChartClassFilterFactory;